<template>
  <div v-if="$canAccess(['project-manager', 'admin'])">
    <h2 class="font-bold text-18px pb-0.5 py-3">Impersonate users</h2>
    <div class="bg-white p-2 mb-0.5 rounded-md border border-grayNeutralLight flex items-center justify-between flex-wrap gap-1">
      <div :class="`text-grayNeutralDark w-full`">
        <button
          @click="openUsers"
          class="w-full flex items-center justify-center gap-1 el-button w-full flex items-center gap-1 el-button--danger"
        >
          <svg
            class="w-[16px] h-[16px] text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m7 10 1.99994 1.9999-1.99994 2M12 5v14M5 4h14c.5523 0 1 .44772 1 1v14c0 .5523-.4477 1-1 1H5c-.55228 0-1-.4477-1-1V5c0-.55228.44772-1 1-1Z"
            />
          </svg>

          <span>Open users list</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import UsersList from './UsersList'

export default {
  props: {
    campaign: {
      type: null,
    },
  },
  data() {
    return {
      direction: 'ltr',
      drawer: false,
    }
  },
  methods: {
    openUsers() {
      this.$Drawer.init(
        {
          propsData: {
            component: UsersList,
            size: '500px',
            direction: 'ltr',
            wrapperClosable: true,
            customClass: 'drawer--half-size',
            meta: { campaign: this.campaign },
          },
        },
        this
      )
    },
  },
}
</script>
